// update modals to resolve dulicate ids on page
const $htcaModalTrigger = $('.horizontal-cta-container button[data-target]'),
			$htcaModal = $('.horizontal-cta-container .modal'),
			$htcaModalH4 = $htcaModal.find('h4');

function a11yAppendIndexToId ($el, attr) {
	$.each($el, function (index) {
		if (attr === 'data') {
			const attributeVal = $(this).data('target');
			$(this).attr('data-target', attributeVal + '-' + index);
		} else if (attr === 'attr') {
			const attributeVal = $(this).attr('id');
			$(this).attr('id', attributeVal + '-' + index);
		}
	});
}

a11yAppendIndexToId($htcaModalTrigger, 'data');
a11yAppendIndexToId($htcaModal, 'attr');
a11yAppendIndexToId($htcaModalH4, 'attr');
